export { default } from './ContentWrapper';